import { Center, Spinner } from "@chakra-ui/react";
import React from "react";
function Loader() {
  return (
    <Center bg="white" height={"100%"}>
      <Spinner />
    </Center>
  );
}

export default Loader;
